
import {GC_Valid_T_String} from "./types/T_String";
import {GC_Valid_T_RegExp} from "./types/T_RegExp";
import {GC_Valid_T_Integer} from "./types/T_Integer";
import {GC_Valid_T_Mobile} from "./types/T_Mobile";
import {GC_Valid_T_Password} from "./types/T_Password";
import {GC_Valid_T_Plate} from "./types/T_Plate";

const ValidatorMap = {
    'Integer':      GC_Valid_T_Integer,
    'Mobile':       GC_Valid_T_Mobile,
    'Password':     GC_Valid_T_Password,
    'String':       GC_Valid_T_String,
    'Plate':       GC_Valid_T_Plate,
    'RegExp':       GC_Valid_T_RegExp
};

export class GC_Validator {

    protected host;
    protected model;
    protected config;

    constructor(host, model, config) {
        this.host       = host;
        this.model      = model;
        this.config     = config;
    }

    public validate(focusOnError) {

        let idx, column, rules, conf, typeName, typeError, validator, sub_pass, sub_index;

        let all_succ = true;

        for (column in this.config) {

            if (!Object.prototype.hasOwnProperty.call(this.config, column)) { continue; }
            // console.log(['validate-column', column, this.model[column]]);

            rules = this.config[column];

            sub_pass = 0;
            sub_index = 0;

            // 可能配置了多条 OR 关系的规则，逐一检查
            for (idx = 0; idx < rules.length; idx++) {

                conf        = rules[idx];
                typeName    = conf[0];
                typeError   = conf[2];

                // console.log(['check-conf', column, typeName, idx, conf]);
                // console.log(['type-class', column, typeName, ValidatorMap[ typeName ]]);

                // 未定义的配置
                if ( !ValidatorMap[ typeName ] ) { continue; }

                validator = new ValidatorMap[ typeName ](conf[1]);

                sub_pass = validator.validate(this.model[column]) ? 1 : 0;

                if (1 === sub_pass) {break;}

            }   // inner-foreach

            all_succ    = 1 === sub_pass;

            if (!all_succ) { break; }

        }   // outer-foreach

        if (!all_succ) {
            this.host.$notifyError(typeError);
            if (focusOnError) {
                focusOnError(column, sub_index);
            }
        }

        return  all_succ;

    }

}
